import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('OrderFilter', OrderFilterData);

  OrderFilterData.$inject = ['DocumentFilter', 'ORDERS'];

  function OrderFilterData(DocumentFilter, ORDERS) {
    var OrderFilter = function() {
      DocumentFilter.call(this);
      this.setPage(ORDERS.pagination.defaultPage);
      this.setPageSize(ORDERS.pagination.defaultPageSize);
      this.setSorts(ORDERS.pagination.defaultSort);

      this.status = ORDERS.status.defaultStatus;
      this.documentTypes = ORDERS.type.defaultTypes;
    };

    OrderFilter.prototype = Object.create(DocumentFilter.prototype);

    return OrderFilter;

    /////////////////////
  }
})();
